import React from 'react';
import * as Styled from './styled';

export interface CardProps {
	children: React.ReactNode;
	heading: React.ReactNode;
	image: string;
}

export const Card = ({ heading, children, image }: CardProps) => (
	<Styled.CardWrapper>
		<Styled.CardImage src={image} alt="" />
		<Styled.CardText>
			{/* eslint-disable-next-line @atlaskit/design-system/use-heading */}
			<h2>{heading}</h2>
			<br />
			{children}
		</Styled.CardText>
	</Styled.CardWrapper>
);
